import analytics from '@/shared-utils/analytics'
import type { IGoogleAnalyticsFourMarketingTracking } from '@pcln/contentful-components'
import type { HeroAnalyticsTracking } from '@pcln/horizon-customer-growth-components'

function handleHeroCollectionSelect(analyticsTracking?: HeroAnalyticsTracking) {
  if (analyticsTracking?.parameters) {
    analytics.fireGA4Event({
      event: 'select_promotion',
      attributes: {
        ...analyticsTracking.parameters.attributes,
      } as IGoogleAnalyticsFourMarketingTracking['attributes'],
    })
  }
}

function sanitizeLink<T extends { url: string; appUrl?: string }>(link?: T) {
  if (!link) return undefined
  const url = link.url || link.appUrl
  return url ? { ...link, url } : undefined
}

export { handleHeroCollectionSelect, sanitizeLink }
